const selector = {
    cartCheckout: document.querySelector('#cart-checkoutbtn'),
    checkoutSticky: document.querySelector('.checkoutbtn-sticky'),
    clearBtn : document.querySelector("#clear-discount-btn"),
    applyBtn : document.querySelector("#apply-discount-btn"),
    discountCodeError : document.querySelector("#discount-code-error"),
    discountCodeWrapper : document.querySelector("#applied-discount-code .applied-discount-code-wrapper"),
    discountCodeValue : document.querySelector("#applied-discount-code .applied-discount-code-value"),
    discountCodeInput : document.querySelector("#discount-code-input"),
    totalCartSelector : document.querySelector("[data-sub-total]"),
    totalCartSubSelector : document.querySelector("[data-carttotal] .money"),
};

var currentEle;
var authorization_token;
var checkoutContainer;

class templateCartJS {
    constructor() {
      let ajaxForm = document.querySelector("ajax-cart");
      // this.stickyCheckout();
      ajaxForm.manageComKit();
      checkoutContainer = document.createElement('div');
      document.body.appendChild(checkoutContainer);
      if (localStorage.discountCode){ this.applyDiscount( JSON.parse(localStorage.discountCode).code);}
      selector.applyBtn.addEventListener("click",(event)=>{
        event.preventDefault()
        this.applyDiscount(selector.discountCodeInput.value);
      });

      selector.clearBtn.addEventListener("click",(event)=>{
        event.preventDefault()
          this. clearDiscount();
      });

      document.querySelector("[data-add-recently-remove]").addEventListener("click",()=>{
        this.addRecentlyDeleted();
      });
      document.querySelector("[data-back-btn]").addEventListener("click",(event)=>{
        event.preventDefault();
        window.history.back();
      })

      
    };

    addRecentlyDeleted(){
      let isFreeKitExist;
      document.querySelectorAll("[data-comkit-btn-text]").forEach(ele=>{
        if(ele.innerText == 'ADDED'){
          isFreeKitExist = true;
        }
      });
      if (isFreeKitExist) {
        alert("Free Product is already added to your cart.");
        return true;
      }
      let addItems = [];
      let addOnJSON = {
        id: window.window.globalVariables.recently_remove_variant,
        quantity: 1
      }
      addItems.push(addOnJSON);
      const body = JSON.stringify({
        items: addItems
      });
   
    
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then(() => {
        let cartElement = document.querySelector('ajax-cart');
        cartElement.getCartData('open_drawer');
        document.querySelector("[data-recenty-remove-wrap]").classList.add("d-none");
    
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        
      });
    }

    applyDiscount(code) {
    
        const _this = this;
        selector.applyBtn.innerHTML = "APPLYING <div class='loader'></div>";
        selector.applyBtn.style.pointerEvents = "none";
        let discountApplyUrl = "/discount/"+code+"?v="+Date.now()+"&redirect=/checkout/";
        fetch(discountApplyUrl, {}).then(function(response) { return response.text(); })
        .then(function(data) {
          checkoutContainer.innerHTML = data;
          const checkout_json_url = '/wallets/checkouts/';
          if(checkoutContainer.querySelector('[name="shopify-checkout-api-token"]')){
            authorization_token = checkoutContainer.querySelector('[name="shopify-checkout-api-token"]').content.replace('\\n', '=').replaceAll('"', '');
          }else{
            authorization_token = checkoutContainer.querySelector('[name="serialized-shopify-checkout-api-token"]').content.replace('\\n', '=').replaceAll('"', '');
          }
          checkoutContainer.remove();
          fetch('/cart.js', {}).then(function(res){return res.json();})
          .then(function(data){
            let body = {"checkout": {"discount_code": code,"line_items": data.items}}
            fetch(checkout_json_url, {
              "headers": {
                "accept": "*/*", "cache-control": "no-cache",
                "authorization": "Basic " + authorization_token,
                "content-type": "application/json, text/javascript",
                "pragma": "no-cache", "sec-fetch-dest": "empty",
                "sec-fetch-mode": "cors", "sec-fetch-site": "same-origin"
              },
              "referrerPolicy": "strict-origin-when-cross-origin",
              "method": "POST", "mode": "cors", "credentials": "include",
              "body": JSON.stringify(body)
          })
          .then(function(response) { return response.json() })
          .then(function(data) {
            if(data.checkout && data.checkout.applied_discounts.length > 0){
              selector.discountCodeWrapper.style.display = "inline";
              selector.discountCodeError.innerHTML = "";
              selector.discountCodeValue.innerHTML = data.checkout.applied_discounts[0].title ;
              let localStorageValue = {
                'code': code.trim(),
                'totalCart': data.checkout.total_line_items_price
              };
              localStorage.setItem("discountCode", JSON.stringify(localStorageValue));
            
            
              if(data.checkout.applied_discount.value_type == "percentage"){
                
                selector.totalCartSelector.innerHTML =`<span class='text-danger d-none'>${ parseInt(data.checkout.applied_discount.value)}% Off</span>` + "<s class='text-gray-300'>" + data.checkout.total_line_items_price + "</s> " + data.checkout.total_price ;
                selector.totalCartSubSelector.innerHTML = `<span class='text-danger d-none'>${ parseInt(data.checkout.applied_discount.value)}% Off</span>`+ "<s class='text-gray-300'>" + data.checkout.total_line_items_price + "</s> " + data.checkout.total_price;
                
              }else{
                selector.totalCartSelector.innerHTML = "<s class='text-gray-300'>" + data.checkout.total_line_items_price + "</s> " + data.checkout.total_price;
                selector.totalCartSubSelector.innerHTML = "<s class='text-gray-300'>" + data.checkout.total_line_items_price + "</s> " + data.checkout.total_price;
                
              }
             selector.discountCodeValue.value = "";

            }else{
              selector.discountCodeValue.innerHTML = "";
              selector.discountCodeWrapper.style.display = "none";
              selector.discountCodeInput.value ='';
              localStorage.removeItem("discountCode");
              selector.discountCodeError.innerHTML = "Please apply the coupon code on the checkout page."
            }
          }).finally(function(params) {
            selector.applyBtn.innerHTML = "APPLY";
            selector.applyBtn.style.pointerEvents = "all";
          });
        });
      });
    }

    clearLocalStorage() {
      selector.discountCodeWrapper.style.display = "none";
      selector.discountCodeValue.value = "";
      selector.totalCartSelector.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
      selector.totalCartSubSelector.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
      localStorage.removeItem("discountCode");
    }

    clearDiscount() {
        selector.discountCodeValue.value = "";
        selector.discountCodeError.innerHTML = "";
        this.clearLocalStorage();
        fetch("/discount/CLEAR");
      }


  //   stickyCheckout() {
  //     let hasScrolledPast = false;
      
  //     const observer = new IntersectionObserver(entries => {
  //         entries.forEach(entry => {
  //             if (entry.isIntersecting) {
  //                 selector.checkoutSticky.classList.remove('active');
  //                 hasScrolledPast = false;
  //             } else {
  //                 hasScrolledPast = true;
  //             }
  //         });
  //     });
  
  //     observer.observe(selector.cartCheckout);
  
  //     window.addEventListener('scroll', () => {
  //         if (hasScrolledPast) {
  //             selector.checkoutSticky.classList.add('active');
  //         }
  //     });
  // }
  
}

typeof templateCartJS !== 'undefined' && new templateCartJS();
